<template>
	<page title="Manage Users">
		<template #actions>
			<create-user @success="reloadUsers" />
		</template>

		<users-table title="All Users" :users="users" />
	</page>
</template>
<script>
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import UsersTable from '@/Pages/Backend/Users/Table'
import CreateUser from '@/Pages/Backend/Users/Create'

export default {
	components: { Page, UsersTable, CreateUser },
	layout: Backend,
	props: {
		users: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	methods: {
		reloadUsers () {
			this.$inertia.reload({
				preserveScroll: true,
				preserveState: true,
				only: ['users']
			})
		}
	}
}
</script>
